import React, { useState } from 'react';
import { Box, Chip } from '@mui/material';
import StoreIcon from '@mui/icons-material/Store';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DataTable, TableColumn, TableAction } from '../../common/table';


const StorePage: React.FC = () => {
    const [loading] = useState(false);

    // Mock data - will be replaced with real API data later
    const mockStoreData = [
        {
            id: '1',
            name: 'Brake Pad Set',
            supplier: 'Mann-Filter',
            code: 'MW123244',
            quantity: 45,
            price: 89.99,
            status: 'IN_STOCK'
        },
        {
            id: '2',
            name: 'Oil Filter',
            supplier: 'Bosch',
            code: 'BO87654',
            quantity: 120,
            price: 15.50,
            status: 'IN_STOCK'
        },
        {
            id: '3',
            name: 'Air Filter',
            supplier: 'Mann-Filter',
            code: 'MW456789',
            quantity: 0,
            price: 25.00,
            status: 'OUT_OF_STOCK'
        },
        {
            id: '4',
            name: 'Spark Plugs Set',
            supplier: 'NGK',
            code: 'NGK98765',
            quantity: 8,
            price: 42.00,
            status: 'LOW_STOCK'
        },
    ];

    const handleEdit = (row: any): void => {
        console.log('Edit product:', row);
        // TODO: Implement edit functionality
    };

    const handleDelete = (row: any): void => {
        if (window.confirm(`Are you sure you want to delete "${row.name}"?`)) {
            console.log('Delete product:', row);
            // TODO: Implement delete functionality
        }
    };

    const handleView = (row: any): void => {
        console.log('View product details:', row);
        // TODO: Implement view functionality
    };

    // Define table columns
    const columns: TableColumn[] = [
        {
            field: 'name',
            headerName: 'Product Name',
            minWidth: 200,
            flex: 1,
            sortable: true,
        },
        {
            field: 'supplier',
            headerName: 'Supplier',
            width: 150,
            sortable: true,
        },
        {
            field: 'code',
            headerName: 'Product Code',
            width: 150,
            sortable: true,
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            width: 100,
            sortable: true,
            align: 'center',
            renderCell: (value) => {
                return <strong>{value}</strong>;
            },
        },
        {
            field: 'price',
            headerName: 'Price',
            width: 120,
            sortable: true,
            align: 'right',
            renderCell: (value) => {
                return `$${value.toFixed(2)}`;
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            sortable: true,
            renderCell: (value) => {
                const statusColors: Record<string, 'success' | 'error' | 'warning' | 'default'> = {
                    IN_STOCK: 'success',
                    OUT_OF_STOCK: 'error',
                    LOW_STOCK: 'warning',
                };
                const color = statusColors[value] || 'default';
                const label = value.replace('_', ' ');

                return (
                    <Chip
                        label={label}
                        color={color}
                        size="small"
                        sx={{ fontWeight: 500 }}
                    />
                );
            },
        },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 220,
            sortable: false,
        },
    ];

    const actions: TableAction[] = [
        {
            label: 'View',
            icon: <VisibilityIcon />,
            color: 'info',
            variant: 'outlined',
            onClick: handleView,
            requirePermission: {
                resource: 'store',
                action: 'read',
            },
        },
        {
            label: 'Edit',
            icon: <EditIcon />,
            color: 'primary',
            variant: 'outlined',
            onClick: handleEdit,
            requirePermission: {
                resource: 'store',
                action: 'edit',
            },
        },
        {
            label: 'Delete',
            icon: <DeleteIcon />,
            color: 'error',
            variant: 'outlined',
            onClick: handleDelete,
            requirePermission: {
                resource: 'store',
                action: 'delete',
            },
        },
    ];

    return (
        <Box className="iauto-admin-page-wrapper" >
            <DataTable
                title="Store"
                icon={<StoreIcon />}
                columns={columns}
                data={mockStoreData}
                actions={actions}
                loading={loading}
                emptyMessage="No Products Found"
                emptyDescription="There are no products in the store yet."
                pagination={true}
                pageSize={50}
                sortable={true}
                stickyHeader={true}
                maxHeight={700}
            />
        </Box>
    );
};

export default StorePage;